import { render, staticRenderFns } from "./EmailNotificationField.vue?vue&type=template&id=5f3e73b0&scoped=true&"
import script from "./EmailNotificationField.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationField.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationField.vue?vue&type=style&index=0&id=5f3e73b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e73b0",
  null
  
)

export default component.exports